import React from "react";
import FormControl from "@material-ui/core/FormControl";
import { ErrorMessage } from "formik";
import PropTypes from "prop-types";
import FileUploaderAjax from "../FileUploaderAjax";
import TextError from "./TextError";

const FormikFileUploaderAjax = ({
  path,
  label,
  field,
  onClear,
  form,
  onComplete,
  value,
  ...props
}) => {
  const handleFileUpload = (data) => {
    form.setFieldValue(field.name, data);
    if (onComplete) onComplete(data);
  };

  const handleClearFileUpload = () => {
    form.setFieldValue(field.name, null);
    if (onClear) onClear();
  };

  return (
    <FormControl style={{ width: "100%", padding: "5px" }}>
      <FileUploaderAjax
        path={path}
        name={field.name}
        label={label}
        value={value}
        onComplete={(data) => handleFileUpload(data)}
        onClear={handleClearFileUpload}
      />
      <ErrorMessage name={field.name} component={TextError} />
    </FormControl>
  );
};

FormikFileUploaderAjax.propTypes = {
  path: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onComplete: PropTypes.func,
  onClear: PropTypes.func,
};

export default FormikFileUploaderAjax;
